import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useGetLeagueId = () => {
  const sportsConfig = useSelector(
    state => state.metadata.sports_competition_config,
  );
  const { pathname } = useLocation();

  const lastSegment = pathname
    .split('/')
    .filter(Boolean)
    .pop();

  const leagueId = useMemo(
    () => {
      if (!sportsConfig || !lastSegment) return null;
      try {
        const config = JSON.parse(sportsConfig);
        return config[lastSegment]?.leagueId || null;
      } catch {
        return null;
      }
    },
    [sportsConfig, lastSegment],
  );

  return leagueId;
};
